const genderMap = {
  1: {
    name: 'male'
  },
  2: {
    name: 'female'
  },
}

export const getGenderName = (id) => {
  return genderMap[id] ? genderMap[id].name : 'unknown';
}

export const urldecode = (str) => {
  return decodeURIComponent(str).replace(/\\x22|%22/g, '"')
}

export const decodeNickname = (str) => {
  return urldecode(str)
}
